import { ErrorResponse} from '@gtpl/shared-models/common-models';
import { AllInsurancesResponseModel, GetInsuranceResponseModel, InsuranceDto } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Raw, Repository } from 'typeorm';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { InsuranceDTO } from './dto/insurance-dto';
import { InsuranceTypeRequest } from './dto/insurance-type.request';
import { InsuranceAdapter } from './dto/insurance.adapter';
import { Insurance } from './dto/insurance.entity';
import { InsuranceRequest } from './dto/insurance.request';

@Injectable()
export class InsuranceService {

    constructor(
      private logService:LogsService,
        @InjectRepository(Insurance)
        private insuranceRepository: Repository<Insurance>,
        private insuranceAdapter: InsuranceAdapter,
      ) {}
    async getInsuranceByType(req:InsuranceTypeRequest): Promise<AllInsurancesResponseModel> {
        try{
          const insurancesDTO: InsuranceDTO[] = [];
            const insuranceDetails = await this.insuranceRepository.find({where:{insuranceType:req.insuranceType}});
            if(insuranceDetails.length>0){
                insuranceDetails.forEach(insuranceEntity => {
                    const convertedinsuranceDto: InsuranceDTO = this.insuranceAdapter.convertEntityToDto(
                      insuranceEntity
                    );
                    insurancesDTO.push(convertedinsuranceDto);
                  });
                  const response = new AllInsurancesResponseModel(true,11108,"Departments retrieved successfully",insurancesDTO);
                return response;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
        }
        }catch (err) {
          throw err;
        }
    }
    async getAllInsurances(req?:UserRequestDto): Promise<AllInsurancesResponseModel> {
        try {
          const insurancesDTO: InsuranceDTO[] = [];
          //retrieves all companies
          const insurancesEntities: Insurance[] = await this.insuranceRepository.find({order :{'companyName':'ASC'}});
          //console.log(insurancesEntities);
          if (insurancesEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            insurancesEntities.forEach(insuranceEntity => {
              const convertedinsuranceDto: InsuranceDTO = this.insuranceAdapter.convertEntityToDto(
                insuranceEntity
              );
              insurancesDTO.push(convertedinsuranceDto);
            });
            const response = new AllInsurancesResponseModel(true,11108,"Insurance retrieved successfully",insurancesDTO);
           if(req?.createdUser){
            const newLogDto = new LogsDto(1,'view', 'Insurance', 0, true, 'Insurance retrieved successfully',req.createdUser,'','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
           }
          
            return response;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        } catch (err) {
          throw err;
        }
      }

      async createInsurance(insuranceDTO: InsuranceDTO, isUpdate: boolean,request:Request): Promise<GetInsuranceResponseModel> {
        try {
          let previousValue;
            console.log(isUpdate);
            if (!isUpdate) {
                const InsuranceEntity = await this.getInsuranceDetailsWithoutRelations(insuranceDTO.companyName);
                if (InsuranceEntity) {
                    throw new GetInsuranceResponseModel(false,11104, 'Insurance already exists');         
                } 
            // var notificationStatus='Created';
            }else{
              const insurancePrev = await this.insuranceRepository.findOne({where:{insuranceId:insuranceDTO.insuranceId}})
              previousValue = insurancePrev.companyName;
                const InsuranceEntity = await this.getInsuranceDetailsWithoutRelations(insuranceDTO.companyName);
                if(InsuranceEntity){
                    if(InsuranceEntity.insuranceId!=insuranceDTO.insuranceId) {
                        throw new GetInsuranceResponseModel(false,11104, 'Insurance already exists');      
                    }
                }
            }

            // else{
            // var notificationStatus='Updated';
            // }
            const convertedInsuranceEntity: Insurance = this.insuranceAdapter.convertDtoToEntity(insuranceDTO,isUpdate);
            const savedInsuranceEntity: Insurance = await this.insuranceRepository.save(
            convertedInsuranceEntity
            );
            const savedDepartmentDto: InsuranceDTO = this.insuranceAdapter.convertEntityToDto(savedInsuranceEntity);
            if (savedDepartmentDto) {
              const presenVal = savedDepartmentDto.companyName
            // generating resposnse
            const response = new GetInsuranceResponseModel(true,isUpdate ? 11101 : 11100,isUpdate? 'Insurance Updated Successfully': 'Insurance Created Successfully',savedDepartmentDto);
            const name=isUpdate?'updated':'created'
            const displayValue = isUpdate? 'Insurance Updated Successfully': 'Insurance Created Successfully'
            const userName = isUpdate? savedDepartmentDto.updatedUser :savedDepartmentDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'Insurance', savedDepartmentDto.insuranceId, true, displayValue,userName,previousValue,presenVal)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            } else {
            throw new GetInsuranceResponseModel(false,11106,'Insurance saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
      }
        async getInsuranceDetailsWithoutRelations(companyName: string): Promise<Insurance> {
          // tslint:disable-next-line: typedef
          const InsuranceResponse = await this.insuranceRepository.findOne({
          where: {companyName: Raw(alias => `company_name = '${companyName}'`)},
          });
          if (InsuranceResponse) {
          return InsuranceResponse;
          } else {
          return null;
          }
      }
      async activateOrDeactivateInsurance(insuranceReq: InsuranceRequest): Promise<GetInsuranceResponseModel> {
        try {
            const insuranceExists = await this.getInsuranceById(insuranceReq.insuranceId);
            if (insuranceExists) {
                if (insuranceReq.versionFlag !== insuranceExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Insurance information.Refresh and try again');
                } else {
                    
                        const insuranceStatus =  await this.insuranceRepository.update(
                            { insuranceId: insuranceReq.insuranceId },
                            { isActive: insuranceReq.isActive,updatedUser: insuranceReq.updatedUser });
                       
                        if (insuranceExists.isActive) {
                            if (insuranceStatus.affected) {
                                const insuranceResponse: GetInsuranceResponseModel = new GetInsuranceResponseModel(true, 10115, 'Insurance is de-activated successfully');
                                return insuranceResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Insurance is already deactivated');
                            }
                        } else {
                            if (insuranceStatus.affected) {
                                const insuranceResponse: GetInsuranceResponseModel = new GetInsuranceResponseModel(true, 10114, 'Insurance is activated successfully');
                                return insuranceResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Insurance is already activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getInsuranceById(insuranceId: number): Promise<Insurance> {
      const Response = await this.insuranceRepository.findOne({
      where: {insuranceId: insuranceId},
      });
      if (Response) {
      return Response;
      } else {
      return null;
      }
  }
}
